module.exports = __webpack_public_path__ + "static/media/orange.91022d7b.png";